import {Component, Input, OnInit} from '@angular/core';
import DataSource from 'devextreme/data/data_source';

@Component({
  selector: 'app-fuel-hourly-consumption-chart',
  templateUrl: './fuel-hourly-consumption-chart.component.html',
  styleUrls: ['./fuel-hourly-consumption-chart.component.scss']
})
export class FuelHourlyConsumptionChartComponent implements OnInit {

  @Input()
  dataSource: DataSource;

  @Input()
  width?: number;

  @Input()
  height?: number;

  constructor() {
  }

  ngOnInit() {
  }


  valueAxisAddUnit(label) {
    return label.valueText + ' L/h';
  }
}
